import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { User, MapPin, ChevronDown } from 'lucide-react';
import { useCustomerAuth } from '../contexts/CustomerAuthContext';
import OTPLoginModal from './OTPLoginModal';

const HIDDEN_HEADER_ROUTES = ['/admin', '/superadmin'];

const TopHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated } = useCustomerAuth();
  const [showLogin, setShowLogin] = useState(false);

  const shouldHide = HIDDEN_HEADER_ROUTES.some(r => location.pathname.startsWith(r));
  if (shouldHide) return null;

  // Don't show on venue/book/community pages (they have their own back headers)
  const isSubPage = ['/venue/', '/book/', '/community/', '/about'].some(r => location.pathname.startsWith(r));
  if (isSubPage) return null;

  return (
    <>
      {showLogin && (
        <OTPLoginModal
          onClose={() => setShowLogin(false)}
          onSuccess={() => setShowLogin(false)}
        />
      )}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-lg border-b border-slate-100" data-testid="top-header">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between h-14">
            {/* Logo */}
            <Link to="/" className="flex items-center" data-testid="header-logo">
              <span className="font-logo text-xl font-black text-[#0A2C93] tracking-tight">
                PlaySpaces
              </span>
            </Link>

            {/* Right side */}
            <div className="flex items-center gap-3">
              {/* Location */}
              <button
                className="hidden sm:flex items-center gap-1 text-sm text-[#737373] hover:text-[#0A2C93] transition-colors"
                data-testid="location-selector"
              >
                <MapPin className="w-3.5 h-3.5" />
                <span className="font-body font-semibold">Bengaluru</span>
                <ChevronDown className="w-3 h-3" />
              </button>

              {/* Auth */}
              {isAuthenticated && user ? (
                <button
                  onClick={() => navigate('/profile')}
                  className="flex items-center gap-2 pl-2 pr-3 py-1.5 rounded-full bg-[#0A2C93]/5 hover:bg-[#0A2C93]/10 transition-colors"
                  data-testid="header-profile-link"
                >
                  <div className="w-7 h-7 rounded-full bg-[#0A2C93] flex items-center justify-center">
                    <span className="text-xs font-bold text-white font-heading">
                      {(user.name || user.phone || '?')[0].toUpperCase()}
                    </span>
                  </div>
                  <span className="text-sm font-heading font-semibold text-[#0A2C93] hidden sm:inline">
                    {user.name || `+91 ${user.phone}`}
                  </span>
                </button>
              ) : (
                <button
                  onClick={() => setShowLogin(true)}
                  className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#0A2C93] hover:bg-[#082273] text-white text-sm font-heading font-semibold transition-colors"
                  data-testid="header-login-btn"
                >
                  <User className="w-4 h-4" />
                  <span>Login</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default TopHeader;
